export const DELETE_CERT_USER = "DELETE_CERT_USER";
export const SET_CERT_USER = "SET_CERT_USER";
export const SET_CONTRIBUTOR = "SET_CONTRIBUTOR";
export const CHANGE_CERT_STATUS = "CHANGE_CERT_STATUS";
export const CHANGE_PRE_MEMBERSHIP = "CHANGE_PRE_MEMBERSHIP";
export const ADD_CERT_USER = "ADD_CERT_USER";
export const CERT_COURSE_UNENROLL = "CERT_COURSE_UNENROLL";
export const EDIT_CERT_USER = "EDIT_CERT_USER";
